/**
 * IntervenantLayout.js — Wrapper léger v3.9 (refactor PROMPT CHIRURGICAL)
 * Source unique : components/Layout/AppLayout.js
 */
import React from 'react';
import AppLayout from '../components/Layout/AppLayout';
import { INTERVENANT_NAV } from '../config/roleNavigation';

const IntervenantLayout = () => <AppLayout navItems={INTERVENANT_NAV} />;

export default IntervenantLayout;